import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet segmented control: the track behind the segments.
export default class BarBackgroundColor extends BackgroundColor {
  static userInterfaceComponent = {
    label: "Bar Background",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      displayAsSelectInput: true,
      colorContext: "Backgrounds",
    },
  };

  static defaultValue = {
    value: "light",
    source: "theme.background",
  };
}
